import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { UsersService } from 'src/app/shared/services/users.service';
import notify from 'devextreme/ui/notify';

@Component({
  selector: 'app-user-popup-update-email',
  templateUrl: './user-popup-update-email.component.html',
  styleUrls: ['./user-popup-update-email.component.scss']
})
export class UserPopupUpdateEmailComponent implements OnInit {
  // IN
  @Input() visible: boolean;
  @Input() user: any;
  
  // OUT
  @Output() 
  onClose = new EventEmitter<any>();

  public newEmail: string;

  constructor(
    private user_service: UsersService
  ) { }

  ngOnInit() {
  }
  
  updateEmail() {      
    this.user_service.updateEmail(this.user.id, this.newEmail).toPromise()
    .then(res => {
      if(res.error) {
        notify(res.error.message, 'danger', 1000);
      } else {
        notify('Se ha actualizado con éxito el Email, y se envio un correo electronico con la información para iniciar sesión', 'success', 1000);
        this.user.email = this.newEmail;
        this.close({
          email: this.newEmail
        });
      }
    })
    .catch(error => {
      console.log('********************** ERROR *************************');
      console.log(error);
      notify(error.message, 'danger', 1000);
    });
  }

  close(data?) {
    this.onClose.emit({
      data: data
    });
  }

}
